export const minimalInputSx = {
    '& .MuiOutlinedInput-root': {
        fontSize: '0.75rem',
        py: 0,
        '& fieldset': { borderColor: 'divider' },
        '&:hover fieldset': { borderColor: 'text.secondary' },
    },
}

export type FilterChipState = 'unselected' | 'include' | 'exclude'

export const filterChipSx = (state: FilterChipState) => ({
    fontSize: '0.6875rem',
    height: 24,
    bgcolor:
        state === 'include'
            ? 'primary.dark'
            : state === 'exclude'
              ? 'error.main'
              : 'transparent',
    color: state === 'unselected' ? 'text.primary' : 'white',
    border: '1px solid',
    borderColor:
        state === 'include'
            ? 'primary.dark'
            : state === 'exclude'
              ? 'error.main'
              : 'grey.300',
    transition: 'background-color 150ms, color 150ms',
    '&:hover': {
        bgcolor:
            state === 'unselected'
                ? 'primary.light'
                : state === 'include'
                  ? '#fce4ec'
                  : 'grey.200',
        color: 'text.primary',
    },
    '& .MuiTouchRipple-root': { display: 'none' },
})

export const toggleChipSx = (isSelected: boolean) => ({
    ...filterChipSx(isSelected ? 'include' : 'unselected'),
    '&:hover': {
        bgcolor: isSelected ? 'grey.200' : 'primary.light',
        color: 'text.primary',
    },
})

const tagBase = {
    px: 1,
    py: 0.25,
    borderRadius: 2,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
    cursor: 'pointer',
}

const removalHover = {
    '&:hover': {
        bgcolor: 'grey.200',
        color: 'text.primary',
    },
}

export const minimalTagSx = (hasToggle: boolean) => ({
    ...filterChipSx('include'),
    ...tagBase,
    ...(hasToggle ? { cursor: 'default', '&:hover': {} } : removalHover),
})

export const excludeTagSx = {
    ...filterChipSx('exclude'),
    ...tagBase,
    cursor: 'default',
    '&:hover': {},
}

export const datePickerSlotProps = {
    textField: {
        size: 'small' as const,
        sx: {
            ...minimalInputSx,
            flex: 1,
            '& .MuiInputLabel-root': { fontSize: '0.75rem' },
        },
    },
    openPickerIcon: { sx: { fontSize: '1rem' } },
}

export const compactListboxProps = {
    sx: {
        '& .MuiAutocomplete-option': {
            fontSize: '0.75rem',
            py: 0.5,
            minHeight: 'unset',
        },
    },
}

export const smallCheckboxLabelSx = {
    '& .MuiFormControlLabel-label': { fontSize: '0.6875rem' },
}
